import axios from 'axios';

export const search = async (searchTerm) => {
  try {
    const response = await axios.post('https://api.iskenderun.bel.tr/Search', { searchTerm });
    return response.data;
  } catch (error) {
    console.error('Search error:', error);
    return {
      isSuccess: false,
      statusCode: error.response?.status || 500,
      resultMessage: 'Arama sırasında bir hata oluştu',
      errors: [error.message],
      data: []
    };
  }
};
